import { EnglishArabicDTO, FileDTO } from "bnsights-control-library"
export class HelpCenterItemModel {
  ID: number;
  IDEncrypted: string;
  Title: EnglishArabicDTO = new EnglishArabicDTO();
  Description: EnglishArabicDTO = new EnglishArabicDTO();
  Html:EnglishArabicDTO = new EnglishArabicDTO();
  IsHidden: boolean;
  IsParent: boolean;
  IsSection:boolean;
  LogoFileID?:number;
  LogoFileDTO:FileDTO;
  Permissions:EnglishArabicDTO[]=[];
  PermissionSetIDs :number[]=[];
  PermissionsStr: string;
  ParentID?: number;
  ParentIDEncrypted: string;
  Children: HelpCenterItemModel[] = [];
}
